import {createPage, setPageContent} from '@/tests';

describe('Drawer e2e', () => {
    it('should close drawer if open prop is set to false', async () => {
        const page = await createPage();

        await setPageContent(
            page,
            `                   
            <joy-drawer id="myDrawer" open>
                 <p slot="drawer-header">I am the drawer header</p>
                 <p slot="drawer-subheader">I am the drawer subheader</p>
            </joy-drawer>`,
        );

        await page.$eval('joy-drawer', (elm: any) => {
            elm.open = false;
        });

        await page.waitForChanges();
        const drawer = await page.find('joy-drawer');
        const drawerVisible = await drawer.isVisible();
        expect(drawerVisible).toBe(false);
    });
});
